import React, { useEffect, useState } from 'react';
import { Title } from 'react-admin';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import WbSunnyIcon from '@mui/icons-material/WbSunny';

import ChatView, { DAILY_BRIEF_PROMPT } from './ChatView';
import ConversationList from './ConversationList';
import useAmaStream from './useAmaStream';

const Assistant = () => {
	const { messages, conversationId, isStreaming, send, stop, loadConversation, startNew } = useAmaStream();
	const [refreshKey, setRefreshKey] = useState(0);
	const [prevConvId, setPrevConvId] = useState(null);

	// Bump the conversation list when: a new conversation was created, or streaming ends
	useEffect(() => {
		if (conversationId && conversationId !== prevConvId) {
			setRefreshKey((k) => k + 1);
			setPrevConvId(conversationId);
		}
	}, [conversationId, prevConvId]);

	useEffect(() => {
		if (!isStreaming && conversationId) {
			setRefreshKey((k) => k + 1);
		}
	}, [isStreaming, conversationId]);

	return (
		<Box sx={{ py: 1 }}>
			<Title title="A.M.A" />
			<Box sx={{
				display: 'flex',
				height: 'calc(100vh - 120px)',
				width: '100%',
				maxWidth: 1200,
				mx: 'auto',
				border: '1px solid',
				borderColor: 'divider',
				borderRadius: 1,
				overflow: 'hidden',
			}}>
				<ConversationList
					currentId={conversationId}
					onSelect={loadConversation}
					onNew={startNew}
					refreshKey={refreshKey}
				/>
				<Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minWidth: 0, minHeight: 0 }}>
					<Box sx={{
						px: 2, py: 1,
						borderBottom: '1px solid',
						borderColor: 'divider',
						display: 'flex',
						alignItems: 'center',
						gap: 1,
						flexShrink: 0,
					}}>
						<Typography variant="h6" sx={{ flexGrow: 1 }}>A.M.A</Typography>
						<Button
							size="small"
							variant="outlined"
							startIcon={<WbSunnyIcon />}
							onClick={() => send(DAILY_BRIEF_PROMPT, { fresh: true })}
							disabled={isStreaming}
						>
							Brief
						</Button>
					</Box>
					<ChatView
						messages={messages}
						isStreaming={isStreaming}
						send={send}
						stop={stop}
					/>
				</Box>
			</Box>
		</Box>
	);
};

export default Assistant;
